import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TreezorSessionKeepaliveService } from '@core/services/treezor-session-keepalive.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IGNORE_TREEZOR_SESSION_ACTIVITY } from './treezor-session-keepalive.tokens';

@Injectable()
export class TreezorSessionKeepaliveInterceptor implements HttpInterceptor {
  private readonly keepaliveService = inject(TreezorSessionKeepaliveService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(IGNORE_TREEZOR_SESSION_ACTIVITY)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse && this.keepaliveService.shouldTrackUrl(req.url)) {
          this.keepaliveService.registerRefreshingRequest(req.url);
        }
      })
    );
  }
}

